import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
`;

export const Controls = styled.div`
  position: absolute;
  z-index: 100;
  top: 10px;
  right: 10px;
  
  align-items: center;
  grid-auto-flow: column;
  display: inline-grid;
`;
